import type { FC } from "react";
import { memo } from "react";
import * as Styled from "./style";

type Props = {
  src: string;
  title: string;
};
const _BusinessTitle: FC<Props> = ({ src, title }) => {
  return (
    <Styled.DivWrapper>
      <Styled.ImageIcon src={src} width="24px" height="24px" alt="icon" />

      <Styled.SpanTitle>{title}</Styled.SpanTitle>
    </Styled.DivWrapper>
  );
};

export const BusinessTitle = memo(_BusinessTitle);
